import React, { useState,useRef } from "react";
import { Button } from "primereact/button";
import { Avatar } from "primereact/avatar";
import { Badge } from "primereact/badge";
import { Toast } from 'primereact/toast';

import "./style.scss";

import Offer from "../Offer";
import CreateOffer from "../CreateOffer";
import { useSelector } from "react-redux";
import { deleteRequest } from "../../services";

const Request = (props) => {
  const userInfo = useSelector((state) => state.redux.userInfo);
  const [addOffer, setAddOffer] = useState(false);
  const toast = useRef(null);
  const { request } = props;

  const isRequestOwner = () =>{
    return request.user.id === userInfo.id;
  }

  const getStatus = () => {
    switch (request.status) {
      case "pending":
        return <Badge value="Pending" severity="warning"></Badge>;
      case "completed":
        return <Badge value="Completed" severity="success"></Badge>;
      case "running":
        return <Badge value="Running" severity="info"></Badge>;
        default:
        return <Badge value="Pending" severity="warning"></Badge>;
    }
  };

  const closeAddOffer = (isAdded = false) =>{
    setAddOffer(false);
    if(isAdded){
      props.reload();
    }
  }

  const deleteRequestHandler = () =>{
    deleteRequest(request.id).then((response) =>{
      toast.current.show({severity:'success', summary: 'Success Message', detail:'Request Deleted Successfully', life: 3000});
      props.reload();
    });
  }

  
  return (
    <React.Fragment>
       <Toast ref={toast} />
       <div className="row request-container">
      <Toast ref={toast} />
      {addOffer && (
        <CreateOffer
          closeAdd={(isAdded) => closeAddOffer(isAdded)}
          requestID={request.id}
        />
      )}
      <div className="col-12 d-flex justify-content-between">
        <div className="d-flex align-items-center mb-3">
          <Avatar icon="pi pi-user" className="mr-2 avatar" size="large" />
          <p className="mx-2 my-0 font-bold">{request.user.name}</p>
        </div>
        {isRequestOwner() && <div className="actions">
          {/* <Button
            className="p-button-outlined p-button-rounded edit"
            icon="pi pi-pencil"
          /> */}
          <Button
          onClick={deleteRequestHandler}
            className="p-button-outlined p-button-rounded delete"
            icon="pi pi-trash"
          />
        </div>}
      </div>
      <div className="col-4">
        <p>
          Energy : <span className="value">{request.energy} kWh</span>
        </p>
      </div>
      <div className="col-4">
        <p>
          Status :{" "}
          <span className="value">
            {getStatus()}
          </span>
        </p>
      </div>
      <div className="col-4">
        <p>
          Price :{" "}
          <span className="value">
            {request.minPrice} - {request.maxPrice} $ / kWh
          </span>
        </p>
      </div>
      <div className="col-4">
        <p>
          Number of Offers :{" "}
          <span className="value">{request.offersCount}</span>
        </p>
      </div>

      <div className="row px-4">{request.description}</div>

      {!isRequestOwner() && request.isPending && userInfo.editable && <div className="row justify-content-end add-offer">
        <Button
          icon="pi pi-plus"
          onClick={() => setAddOffer(true)}
          iconPos="left"
          label="Add New Offer"
        />
      </div>}

      {request.offersCount > 0 && <div className="offers">
        {request.offers.map((offer, index) => (
          <Offer isPending={request.isPending} disabled={offer.disabled} isMyRequest={isRequestOwner()} reload={() => props.reload()}  key={index} offer={offer} />
        ))}
      </div>}
    </div>
    </React.Fragment>
 
  );
};

export default Request;
